import { makeStyles } from '@mui/styles';
import { Typography } from 'apollo-react';
import ClipboardSearch from 'apollo-react-icons/ClipboardSearch';
import React from 'react';

import RuntimeSavedSearch from './ssRuntimeSavedSearch';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FCM_CONTAINER_STYLES } from '../../constants/runtime.constants';

const useStyles = makeStyles(FCM_CONTAINER_STYLES);

const SSSavedSearch = ({ label, isEditor, isControlAddedFCM, isControlChangedFCM, ...props }) => {
  const classes = useStyles({ isControlAddedFCM });

  if (isEditor) {
    return (
      <div style={{ display: 'flex' }}>
        <Typography style={{ marginRight: 15 }}>{label || 'ssSavedSearch'}</Typography>
        <ClipboardSearch color="primary" />
      </div>
    );
  }

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div className={classes.changesModeWrapper} data-ss-id={props.id}>
        <div className={classes.control}>
          <RuntimeSavedSearch {...props} />
        </div>
        {isControlChangedFCM && (
          <div className={classes.changesIcon}>
            <ControlChangesIcon id={props.id} />
          </div>
        )}
      </div>
    );
  }

  return <RuntimeSavedSearch {...props} />;
};

export default SSSavedSearch;
